import { Injectable } from '@angular/core';

@Injectable()
export class Utilities {
  public static enumToList(theEnum, filterOutZero: boolean = false){
    const lst = Object.entries(theEnum)
    .filter((e) => !isNaN(e[0] as any))
    .filter((e) => Number(e[0]) > 0)
    .map((e) => {const item = { id: Number(e[0]), name: e[1].toString().replace(/([A-Z]+)/g, ' $1').trim() }; return item; })
    .sort((a, b) => a.name.localeCompare(b.name));
    return (filterOutZero) ? lst.filter((i) => i.id !== 0) : lst;
  }

  public static groupBy(objectArray, property) {
    return objectArray.reduce((acc, obj) => {
      const key = obj[property];
      if (!acc[key]) {
        acc[key] = {name: key, items: []};
      }
      acc[key]['items'].push(obj);
      return acc;
    }, {});
  }

  public static patchLookupArray(arr, newIds, idProperty){
    arr = arr || [];
    
    // remove items no longer required
    const f = arr.filter((i) => newIds.indexOf(i[idProperty]) > -1);
    arr.splice(0, arr.length);
    arr.push(...f);
    
    // return new
    const e = arr.map((i) => i[idProperty]);
    return newIds.filter((i) => e.indexOf(i) < 0);
  }

  public static hexToRgb(hex: string){
    return hex.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, (m, r, g, b) => '#' + r + r + g + g + b + b)
      .substring(1).match(/.{2}/g)
      .map((x) => parseInt(x, 16));
  }

  public static rgbToHex(r, g, b){
    return '#' + [r, g, b].map((x) => x.toString(16).padStart(2, '0')).join('');
  }

  public static rgbStringToRgb(rgb: string){
    // Choose correct separator
    const sep = rgb.indexOf(',') > -1 ? ',' : ' ';
    
    // Turn "rgb(r,g,b)" into [r,g,b]
    return rgb.substr(4).split(')')[0].split(sep).map((x) => Number(x));
  }

  public static contrastColour(color: string){
    color = Utilities.getColor(color);
    let rgb = [];
    if (color.includes('rgb')){
      rgb = this.rgbStringToRgb(color);
    }
    if (color.includes('#')){
      rgb = this.hexToRgb(color);
    }
    if (rgb.length === 3){
      return (((((rgb[0] * 299) + (rgb[1] * 587) + (rgb[2] * 114)) / 1000)) > 130) ? '#000000' : '#ffffff';
    }
    else{
      return '#000000';
    }
  }

  public static getColor(color: string){
    const ctx = document.createElement('canvas').getContext('2d');
    ctx.fillStyle = color;
    return ctx.fillStyle;
  } 

  // MRD - Angular 7.x + material has a bug which means the aria-label for the internal svg is not set as expected
  // the following bit of code attempts to circumvent the bug so the svg accessible name can be resolved and thus
  // not cause a problem when assessing web accessibility.  Note for this to work the checkbox needs to have an id set
  public static patchCheckboxAria(){
    const checkboxes = document.getElementsByClassName('mat-checkbox');
    for (var i=0; i < checkboxes.length; i++) {
      const svg = checkboxes[i].getElementsByClassName('mat-checkbox-checkmark');
      if (svg.length > 0) {
        svg[0].setAttribute('aria-labelledby', checkboxes[i].id);
      }
      const input = checkboxes[i].getElementsByClassName('mat-checkbox-input');
      if (input.length > 0) {
        input[0].removeAttribute('aria-checked');
      }
    }
  }

  public static applyChipListAccessibilityHacks() {
    const chiplist = document.getElementsByClassName('mat-chip-list');
    for (var i=0; i < chiplist.length; i++) {
      chiplist[i].removeAttribute('aria-orientation');
      chiplist[i].removeAttribute('aria-required');
      chiplist[i].removeAttribute('aria-multiselectable');
    }
  }
}
